import { useEffect, useState } from 'react';

const useScrollbarSize = () => {
    const [scrollbarSize, setScrollbarSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        outer.style.position = 'absolute';
        outer.style.top = '-9999px';
        document.body.appendChild(outer);

        const inner = document.createElement('div');
        outer.appendChild(inner);

        const width = outer.offsetWidth - outer.clientWidth;
        const height = outer.offsetHeight - outer.clientHeight;

        setScrollbarSize({ width, height });

        document.body.removeChild(outer);
    }, []);

    return scrollbarSize;
};

export default useScrollbarSize;
